<template>
  <div id="app">
        <!-- Titlu dinamic -->
    <Head>
      <title>{{ $t("pageTitle") }}</title>
    </Head>
<header class="bg-light py-3 shadow-sm border-blue">
  <div class="container">
    <nav class="navbar navbar-expand-lg navbar-light">
      <!-- Logo -->
      <router-link class="navbar-brand d-flex align-items-center" to="/">
        <img :src="logo" alt="Logo" class="logo me-2" />
        <h1 class="header-title mb-0">{{ $t("header.title") }}</h1>
      </router-link>

      <!-- Buton hamburger pentru mobil -->
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Meniu -->
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav ms-auto">
          <li class="nav-item">
            <router-link class="nav-link fw-bold" to="/">{{ $t("navigation.home") }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link fw-bold" to="/bilete">{{ $t("navigation.tickets") }}</router-link>
          </li>

          <!-- 🔹 Adăugăm meniul pentru Informații Publice -->
          <li class="nav-item">
            <router-link class="nav-link fw-bold" to="/informatii-publice">{{ $t("navigation.public_info") }}</router-link>
          </li>

          <!-- 🔹 Adăugăm meniul pentru Conducere -->
          <li class="nav-item">
            <router-link class="nav-link fw-bold" to="/conducere">{{ $t("navigation.leadership") }}</router-link>
          </li>

          <!-- Dacă utilizatorul este autentificat -->
          <li v-if="isAuthenticated" class="nav-item dropdown">
            <a class="nav-link dropdown-toggle fw-bold" href="#" role="button" data-bs-toggle="dropdown"
              aria-expanded="false">
              {{ userName }}
            </a>
            <ul class="dropdown-menu">
              <li>
                <router-link class="dropdown-item" to="/dashboard">{{ $t("navigation.panel") }}</router-link>
              </li>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="logout">{{ $t("navigation.logout") }}</a>
              </li>
            </ul>
          </li>

          <!-- Dacă utilizatorul NU este autentificat -->
          <li v-else class="nav-item">
            <router-link class="nav-link fw-bold" to="/login">{{ $t("navigation.login") }}</router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link fw-bold" to="/contact">{{ $t("navigation.contact") }}</router-link>
          </li>
        </ul>

        <!-- Dropdown Limbi -->
        <div class="dropdown ms-lg-3 align-self-center">
          <button class="btn btn-outline-dark dropdown-toggle" type="button" id="languageDropdown"
            data-bs-toggle="dropdown" aria-expanded="false">
            {{ currentLang === 'en' ? 'English' : currentLang === 'ro' ? 'Română' : 'български' }}
          </button>
          <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="languageDropdown">
            <li>
              <a class="dropdown-item" href="#" @click.prevent="changeLanguage('en')">
                <img src="@/assets/us-flag.png" alt="English" class="me-2" style="width: 20px;"> English
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="#" @click.prevent="changeLanguage('ro')">
                <img src="@/assets/ro-flag.png" alt="Română" class="me-2" style="width: 20px;"> Română
              </a>
            </li>
            <li>
              <a class="dropdown-item" href="#" @click.prevent="changeLanguage('bg')">
                <img src="@/assets/bg-flag.png" alt="български" class="me-2" style="width: 20px;"> български
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</header>


      <slot></slot>

    <MrFerry />  

    <!-- Buton Back to Top -->
    <button class="btn btn-primary back-to-top" v-if="showBackToTop" @click="scrollToTop">
      <i class="fa fa-arrow-up"></i>
    </button>

    <!-- Cookie Consent -->
    <!-- Cookie Consent -->
    <div v-if="!cookiesAccepted" class="cookie-banner">
      <p>
        {{ $t("cookie.message") }}
        <router-link to="/politica" class="text-light fw-bold">{{ $t("cookie.policyLink") }}</router-link>.
      </p>
      <button class="btn btn-success me-2" @click="acceptCookies">{{ $t("cookie.accept") }}</button>
      <button class="btn btn-danger" @click="declineCookies">{{ $t("cookie.decline") }}</button>
    </div>

<!-- Buton WhatsApp -->
<a href="https://wa.me/+40766638391" target="_blank" class="whatsapp-button">
  <i class="fa fa-whatsapp"></i>
</a>
<footer class="footer bg-dark text-light pt-4 pb-2">
  <div class="container">
    <div class="row gy-4">
      <!-- Link-uri rapide -->
      <div class="col-md-4">
        <h5 class="fw-bold border-bottom pb-2">{{ $t("footer.quickLinks") }}</h5>
        <ul class="list-unstyled">
          <li><router-link class="text-light text-decoration-none" to="/">{{ $t("navigation.home") }}</router-link></li>
          <li><router-link class="text-light text-decoration-none" to="/bilete">{{ $t("navigation.tickets") }}</router-link></li>
          <li><router-link class="text-light text-decoration-none" to="/contact">{{ $t("navigation.contact") }}</router-link></li>
        </ul>
      </div>

      <!-- Politici -->
      <div class="col-md-4">
        <h5 class="fw-bold border-bottom pb-2">{{ $t("footer.legal") }}</h5>
        <ul class="list-unstyled">
          <li><router-link class="text-light text-decoration-none" to="/politica">{{ $t("footer.privacyPolicy") }}</router-link></li>
          <li><router-link class="text-light text-decoration-none" to="/termeni">{{ $t("footer.terms") }}</router-link></li>
        </ul>
      </div>

      <!-- Contact -->
      <div class="col-md-4">
        <h5 class="fw-bold border-bottom pb-2">{{ $t("footer.contactInfo") }}</h5>
        <p><strong>{{ $t("footer.VAT") }}</strong>: RO17670528</p>
        <p><strong>{{ $t("footer.RegComert") }}</strong>: J34/390/2005</p>
        <p><i class="fa fa-phone me-2"></i> +40 766 638 391</p>
        <p><i class="fa fa-envelope me-2"></i> eurobac2005@gmail.com</p>
      </div>
    </div>

    <!-- Banner ANPC -->
    <div class="text-center mt-4">
      <a href="https://anpc.ro" target="_blank" rel="noopener noreferrer">
        <img src="@/assets/anpc.png" alt="ANPC" class="img-fluid" style="max-height: 150px;" />
      </a>
    </div>

    <!-- Credit -->
    <div class="text-center mt-3 small">
      <p class="mb-1">&copy; 2025 {{ $t('footer.company') }} - Eurobac.</p>
      <p>{{ $t('footer.createdBy') }} <a href="https://www.rusin.ro" class="text-decoration-none text-light fw-bold" target="_blank">Luca Rusin</a>.</p>
    </div>
  </div>
</footer>


  </div>
</template>

<script>

import axios from "axios";
import logo from "@/assets/logo.png";
import MrFerry from "@/components/MrFerry.vue"; // ✅ Importăm componenta chat

export default {
  components: { MrFerry }, // ✅ O înregistrăm
  data() {
    return { // Asigură-te că logo-ul este în folderul assets
      currentLang: this.$i18n.locale,
      euroRate: null, // Adăugăm valoarea cursului euro
      logo,
      mobileMenuOpen: false, // Setează limba curentă
      isAuthenticated: false,      
      cookiesAccepted: localStorage.getItem("cookiesAccepted") === "true",
      showBackToTop: false, // Setează dacă utilizatorul este autentificat
    };
  },
  created() {
    
    this.fetchEuroRate(); // Preia valoarea euro la crearea componentei
    
    
  },  mounted() {
    this.checkAuth();
    window.addEventListener("scroll", this.handleScroll);
  },  computed: {
    pageTitle() {
      return this.$route.meta.title || "Feribot Eurobac";
    },
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang; // Schimbă limba folosind vue-i18n
      this.currentLang = lang;
    },     toggleMobileMenu() {
      this.mobileMenuOpen = !this.mobileMenuOpen;
    },   async fetchEuroRate() {
      try {
        const response = await axios.get("https://api.feribot-eurobac.ro/api/euro-rate/"); // Endpoint pentru cursul euro
        this.euroRate = response.data.rate; // Setează cursul în data
        console.log("Cursul euro este:", this.euroRate);
      } catch (error) {
        console.error("Eroare la preluarea cursului euro:", error);
      }
    },async checkAuth() {
  try {
    const response = await axios.get("https://api.feribot-eurobac.ro/client/api/check-auth/", {
      withCredentials: true,
    });

    if (response.data.isAuthenticated) {
      this.isAuthenticated = true;
      this.userName = response.data.client_name;

      // 👇 doar setezi statusul, NU mai redirecționezi
      this.isVerified = response.data.isVerified;
    } else {
      this.isAuthenticated = false;
    }
  } catch (error) {
    this.isAuthenticated = false;
  }
},


    async logout() {
      try {
        await axios.post("https://api.feribot-eurobac.ro/client/api/logout/", {}, {
          withCredentials: true,
        });

        this.isAuthenticated = false;
        this.userName = "";
        this.$router.push("/login");
      } catch (error) {
        console.error("Eroare la logout:", error);
      }
    },    acceptCookies() {
      this.cookiesAccepted = true;
      localStorage.setItem("cookiesAccepted", "true");
    },
    declineCookies() {
      this.cookiesAccepted = true;
      localStorage.setItem("cookiesAccepted", "false");
    },
    handleScroll() {
      this.showBackToTop = window.scrollY > 200;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  }
};
</script>


<style scoped>

/* Cookie Consent */
.cookie-banner {
  position: fixed;
  bottom: 10px;
  left: 10px;
  background: #0056b3;
  color: white;
  padding: 15px;
  z-index: 100;
  border-radius: 8px;
}

/* Back to Top */
.back-to-top {
  position: fixed;
  bottom: 80px;
  right: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  border-radius: 50%;
  transition: all 0.3s;
}

.back-to-top:hover {
  background: #0056b3;
}
footer {
  font-size: 0.9rem;
}
footer h5 {
  font-size: 1.1rem;
  border-bottom: 2px solid #fff;
  padding-bottom: 5px;
  margin-bottom: 10px;
}
footer p {
  margin-bottom: 5px;
}
footer ul {
  padding: 0;
}
footer ul li {
  list-style: none;
}
footer ul li a {
  text-decoration: none;
}/* 🔹 Buton WhatsApp */
.whatsapp-button {
  position: fixed;
  bottom: 20px;
  left: 20px;
  background-color: #25D366;
  color: white;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 28px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease-in-out;
  text-decoration: none;
}

.whatsapp-button:hover {
  transform: scale(1.1);
  background-color: #1ebe5d;
}

.homepage {
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
/* Stilizare pentru titlu */
.header-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: #0056b3; /* Albastru deschis pentru a se potrivi cu fundalul */
  margin: 0;
    line-height: 1;
  white-space: nowrap; /* Evită să se împartă pe mai multe linii */
  vertical-align: middle;
}

.logo {
  height: 50px;
  transition: transform 0.3s;
}

.logo:hover {
  transform: scale(1.1); /* Zoom subtil la hover */
}
.footer {
  background: #001f3f; /* Albastru închis elegant */
  color: white;
  font-size: 1rem;
}
html, body {
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1; /* Se va extinde pentru a umple spațiul */
}
/* Text și link-uri */
.footer p {
  margin: 0;
  font-size: 1rem;
}

.footer-credits {
  font-size: 0.9rem;
  color: #b0c4de; /* Gri-albăstrui discret */
}

/* Link stilizat */
.footer-link {
  color: #f8f9fa; /* Alb moale */
  text-decoration: none;
  font-weight: bold;
  transition: color 0.3s ease-in-out;
}

.footer-link:hover {
  color: #007bff; /* Albastru mai vizibil la hover */
}
/* Header Styling */
header {
  background-color: #143780; /* Dark navy blue */
  color: #ffffff; /* White text for better contrast */
  padding-top: 1rem; /* Adjust padding for a cleaner look */
  padding-bottom: 1rem; /* Padding for the header */
}

/* Header Styling */
header {
  background-color: #ffffff; /* White background */
  color: #143780; /* Navy blue text */
  padding-top: 1rem; /* Adjust padding for a cleaner look */
  padding-bottom: 1rem; /* Padding for the header */
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* Slight shadow for depth */
}



/* Language Selector Button */
.btn-outline-light {
  color: #143780; /* Navy blue text */
  border-color: #143780; /* Navy blue border */
  transition: all 0.3s ease;
}

.btn-outline-light:hover {
  background-color: #ffd700; /* Gold background on hover */
  color: #ffffff; /* White text when hovered */
  border-color: #ffd700; /* Gold border on hover */
}

/* Stilizare pentru butonul de selecție a limbii */
.dropdown button {
  background-color: #f8f9fa; /* Fundal mai deschis */
  color: #004aad; /* Text albastru deschis */
  border: none;
  font-weight: bold;
  padding: 8px 15px;
  transition: background-color 0.3s ease-in-out, box-shadow 0.3s;
}

.dropdown button:hover {
  background-color: #e0e0e0;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

/* Eliminare spațiu de jos din dropdown */
.dropdown-menu {
  padding: 5px 0;
  border-radius: 8px;
  margin-top: 0;
}

/* Stilizare pentru opțiunile din dropdown */
.dropdown-item {
  display: flex;
  align-items: center;
  font-size: 1rem;
  padding: 8px 12px;
  color: #004aad;
  transition: background-color 0.2s ease-in-out;
}

.dropdown-item:hover {
  background-color: #f0f8ff;
}

/* Stilizare pentru iconițele steagurilor */
.flag-icon {
  width: 20px;
  height: 14px;
  margin-right: 8px;
}

.homepage {
  margin: 0;
  padding: 0;
}

.hero-section, .features-section, .about-us-section {
  margin-bottom: 0; /* Adjust this as needed */
}/* In BaseLayout.vue */
body, html {
  margin: 0;
  padding: 0;
  width: 100%;
}
/* Responsivitate */
@media (max-width: 768px) {
  .nav {
    flex-direction: column;
    text-align: center;
  }

  .dropdown {
    margin-top: 10px;
  }
}
/* 🔹 LOGO */
.logo {
  width: 50px;
}
.header-title {
  font-size: 1.5rem;
}

/* 🔹 BORDER ALBASTRU SUB HEADER */
.border-blue {
  border-bottom: 4px solid #0056b3;
}

/* 🔹 NAVIGATION STYLING */
/* Navigation Styles */
.nav-link {
  color: #143780 !important; /* Navy blue for navigation links */
  padding: 0.5rem 1rem;
  text-transform: uppercase;
  font-weight: bold;
  transition: color 0.3s ease-in-out;
}

.nav-link:hover {
  color: #ffd700 !important; /* Gold color on hover for contrast */
}
/* 🔹 DROPDOWN LANGUAGE BUTTON */
.dropdown-menu {
  min-width: 150px;
}
.contact {
  background-color: #001F3F; /* Navy Blue */
  color: #ffffff; /* White */
}

.contact h2 {
  color: #ffffff; /* White */
}

.contact .btn-light {
  background-color: #ffffff;
  color: #001F3F;
  border: none;
  transition: all 0.3s ease;
}

.contact .btn-light:hover {
  background-color: #f0f0f0;
  color: #001F3F;
}

.card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.btn:hover {
  transform: scale(1.1);
  transition: transform 0.3s ease;
}
.contact {
  border-top: 5px solid #FFD700; /* Un accent galben aur pentru tranziție */
  padding-top: 30px;
}


</style>